import React, { FC } from 'react';
import { MessageContainer, ProfileContainer } from './ScreeningMessage.styles';

import { ScreeningMessageTypes } from './types';
import { GatewaySubscriptionTypeNames } from 'auth/constants/subscriptions';
import { Loading } from 'components/atoms';

const ScreeningMessage: FC<ScreeningMessageTypes> = ({
  dueDiligenceType,
  numberOfMatchesFound,
  numberOfRetries,
  state,
}: ScreeningMessageTypes) => {
  let showLoading = false;
  let message: string | null = null;

  const isSelfServiceScreening =
    dueDiligenceType === GatewaySubscriptionTypeNames.SelfServiceScreening;

  const isManagedDueDiligence =
    dueDiligenceType === GatewaySubscriptionTypeNames.ManagedServiceDueDiligence;

  const isManagedServiceScreening =
    dueDiligenceType === GatewaySubscriptionTypeNames.ManagedServiceScreening;

  if (state == 'Errored') {
    message = `Sorry, we've encountered an issue while initiating your ${
      isSelfServiceScreening ? 'Self' : 'Manage'
    } Service Screening order. Please try again later.`;
  } else if (isManagedDueDiligence || isManagedServiceScreening) {
    message = null;
  } else if (isSelfServiceScreening && state === 'New' && numberOfRetries <= 0) {
    showLoading = true;
    message = 'Your screening order is in progress and will be ready soon.';
  } else if (state === 'New' && numberOfRetries > 0) {
    message =
      'The first attempt of ordering this screening has failed, please wait while trying to get a successful response, it can take up to 50 mins';
  } else if (numberOfMatchesFound === 0 && state !== 'New') {
    message = 'No matches found. Review Status Has Been Set To "Complete - No MatchesFound';
  }

  if (!message) {
    return null;
  }

  return (
    <ProfileContainer>
      <MessageContainer>
        {showLoading ? (
          <>
            <Loading /> {message}
          </>
        ) : (
          message
        )}
      </MessageContainer>
    </ProfileContainer>
  );
};

export default ScreeningMessage;
